import React from 'react'
import B2BAudiencePenetrationFor2026 from '../components/B2BAudiencePenetrationFor2026'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'

export default function TheNewRulesOfB2BAudiencePenetrationFor2026() {
  return (
    <div>
      <Header1/> 
      <B2BAudiencePenetrationFor2026/>
      <Footer/>
    </div>
  )
}
